module.exports = __webpack_public_path__ + "img/sr.d04e13ea.svg";